module.exports = __webpack_public_path__ + "img/0.a5e81f19.png";